// type guard for typescript in filter functions

function notNull<T>(x: T | null): x is T {
  return x !== null;
}

export default notNull;
